/** * @author wangmao * @date 2022/5/12 16:47 */
<template>
  <div
    class="hey-nav-bar"
    v-bind="$attrs"
    :class="{ fixed: fixed }"
    :style="{
      background: backgroundColor
    }"
  >
    <div class="safe-area-inset-top" />
    <div class="nav-bar-wrapper" :dir="isRTL ? 'rtl' : 'ltr'">
      <div class="left-wrapper" @click="handleClickLeft">
        <slot name="left">
          <div class="left-arrow" v-if="leftArrow">
            <!--<img src="./../../assets/images/nav-arrow.png" alt="" />-->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="11"
              height="20"
              viewBox="0 0 11 20"
              fill="none"
            >
              <path
                d="M10 19L2 10L10 1V1"
                :stroke="arrowColor"
                stroke-width="2"
              />
            </svg>
          </div>
          <span class="left-text" v-if="leftText">{{ leftText }}</span>
        </slot>
      </div>
      <div class="title-wrapper">
        <slot name="title">
          <span
            class="title-text"
            :style="{ color: titleColor }"
            v-if="title"
            >{{ title }}</span
          >
        </slot>
      </div>
      <div class="right-wrapper" @click="handleClickRight">
        <slot name="right">
          <span class="right-text" v-if="rightText">{{ rightText }}</span>
        </slot>
      </div>
    </div>
  </div>
  <div class="placeholder" v-if="fixed && placeholder" />
</template>

<script>
import { closeWebView } from '../../../../utils/todayUtils'
import { useRouter } from 'vue-router'

export default {
  name: 'HeyNavBar',
  inheritAttrs: false,
  emits: ['click-left', 'click-right'],
  props: {
    // 标题
    title: {
      type: String,
      default: document ? document.title : ''
    },
    // 左侧文案
    leftText: {
      type: String,
      default: ''
    },
    // 是否显示左侧箭头
    leftArrow: {
      type: Boolean,
      default: true
    },
    // 右侧文案
    rightText: {
      type: String,
      default: ''
    },
    // 是否固定在顶部
    fixed: {
      type: Boolean,
      default: true
    },
    // 固定在顶部时，是否在标签位置生成一个等高的占位元素
    placeholder: {
      type: Boolean,
      default: true
    },
    // 导航栏背景色
    backgroundColor: {
      type: String,
      default: '#fff'
    },
    // 是否开启默认的返回操作
    enableDefaultBack: {
      type: Boolean,
      default: true
    },
    // 返回的路由
    backRoute: {
      type: String,
      default: ''
    },
    // 返回类型，back/push/close/replace
    backType: {
      type: String,
      default: 'back'
    },
    arrowColor: {
      type: String,
      default: '#222'
    },
    titleColor: {
      type: String,
      default: '#222'
    },
    // 是否为RTL布局
    isRTL: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const router = useRouter()
    // 点击左侧
    const handleClickLeft = (e) => {
      context.emit('click-left', e)
      // 是否开启默认返回操作，使用 router 返回或者关闭webView
      if (props.enableDefaultBack) {
        if (props.backType === 'back') {
          // 是否有返回的路由,有则返回，否则关掉webView
          hasBackRoute() ? router.back() : closeWebView()
          return
        }
        if (props.backType === 'push') {
          router.push(props.backRoute)
          return
        }
        if (props.backType === 'replace') {
          router.replace(props.backRoute)
          return
        }
        if (props.backType === 'close') {
          closeWebView()
        }
      }
    }

    // 是否有返回的路由
    const hasBackRoute = () => {
      return !!(router && history.state && history.state.back)
    }

    // 点击右侧
    const handleClickRight = (e) => {
      context.emit('click-right', e)
    }

    return {
      handleClickLeft,
      handleClickRight
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/styles/common.scss';

.hey-nav-bar {
  width: 100%;
  position: relative;
  height: 44px;
  z-index: 999;
  &.fixed {
    position: fixed;
    height: 88px;
    top: 0;
    left: 0;
    .nav-bar-wrapper {
      position: fixed;
      top: 44px;
      left: 0;
      z-index: 999;
      margin-top: 0;
    }
  }
  .safe-area-inset-top {
    height: 44px;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
  }
  .nav-bar-wrapper {
    width: 100%;
    height: 44px;
    position: relative;
    margin-top: 44px;
    @include flexbox(
      (
        display: flex,
        align-items: center
      )
    );

    // RTL 布局调整
    &[dir='rtl'] {
      .left-wrapper {
        order: 2; // 在 RTL 下，left-wrapper 放在右侧
        position: absolute;
        right: 0;
        .left-arrow {
          margin-left: 10px;
          margin-right: 16px;
          transform: scaleX(-1); // 翻转箭头方向
        }
      }
      .right-wrapper {
        order: 1; // 在 RTL 下，right-wrapper 放在左侧
        position: absolute;
        left: 0 !important;
        margin-left: 10px;
      }
    }
    &[dir='ltr'] {
      .left-wrapper {
        order: 1;
      }
      .right-wrapper {
        right: 0;
      }
    }

    .left-wrapper {
      flex: none;
      max-width: 20%;
      @include flexbox(
        (
          display: flex,
          align-items: center
        )
      );
      .left-arrow {
        margin-left: 16px;
        margin-right: 10px;
        @include flexbox(
          (
            display: flex,
            align-items: center
          )
        );
        > img {
          height: 18px;
        }
      }
      .left-text {
        font-size: 14px;
        color: #222;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .title-wrapper {
      position: absolute;
      left: 0;
      right: 0;
      height: 100%;
      pointer-events: none;
      @include flexbox(
        (
          display: flex,
          align-items: center,
          justify-content: center
        )
      );
      .title-text {
        padding: 0 10px;
        font-size: 17px;
        font-weight: 600;
        color: #222;
        line-height: 21px;
        text-align: center;
        max-width: 70%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .right-wrapper {
      position: absolute;
      height: 100%;
      // max-width: 20%;
      @include flexbox(
        (
          display: flex,
          align-items: center,
          justify-content: center
        )
      );
      .right-text {
        padding-right: 10px;
        font-size: 14px;
        font-weight: bold;
        color: #1989fa;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}

.placeholder {
  height: 88px;
  width: 100%;
  pointer-events: none;
  opacity: 0;
}
</style>
